<template>
  <div id="pdf">
    <el-row id="dpdf">
      <el-select v-model="value" placeholder="请选择" @change="changePlate" size="mini">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-date-picker size="mini" v-model="expiryDate" type="date" value-format="yyyyMMdd" placeholder="选择日期" :picker-options="pickerOptions" @change="expiryDateChange" style="margin-left: 5px;">
      </el-date-picker>
      <!-- <el-button @click="expiryDateChange" size="mini" :disabled="!expiryDate">查看报价</el-button> -->
      <el-button size="small" @click="$router.push('/')" style="margin-left: 5px;"> 返回商品交易界面 </el-button>
      <el-button @click="downPdf" style="float: right;" size="mini">导出PDF</el-button>
      <el-button @click="downExcel" style="float: right;" size="mini">导出Excel</el-button>
      <el-button type="danger" style="float: right;margin-right: 5px" @click="dialogVisible = true" size="mini"> 导出说明
      </el-button>
    </el-row>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <h3 style="color: #e96900">请使用最新版的谷歌(chrome)或者qq,360浏览器</h3>
      <p>点击导出,打开更多设置,修改左侧参数,如下图所示</p>
      <div>
        <img src="../public/geshi.png" width="100%">
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-row id="ol_article_content">
        <el-col :span="10">
          <img src="../public//logo.png" width="100%" />
        </el-col>
        <el-col :span="14" class="title-right">
          <div class="title-right-top">
            <p>一个月平值场外期权报价表</p>
          </div>
          <div class="title-right-bottom">
            <p>报价日期</p> <p> {{ changeShowDate(nowDate) }} </p>
            <p>到期日期</p> <p> {{ changeShowDate(expiryDate) }} </p>
          </div>
        </el-col>
    </el-row>
      <el-table :data="newData" size="small" :row-class-name="getRowClass" :cell-class-name="getCellClass" v-loading="loading" :header-row-class-name="setTableHeader"
        :span-method="objectSpanMethod" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" 
        element-loading-background="rgba(255, 255, 255, 0.5)">
        <el-table-column label="报价品种">
          <el-table-column prop="CN_name" :label="value" width="98"> </el-table-column>
          <el-table-column prop="name" label="品种" width="120"> 
            <template slot-scope="scope">
              <span> {{ scope.row.name == ''?scope.row.code: scope.row.name }} </span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="标的信息">
          <el-table-column prop="code" label="代码" width="100"> </el-table-column>
          <el-table-column prop="price" label="价格" width="98"> 
            <template slot-scope="scope">
              <span :class="{del: scope.row.isDel}"> {{ scope.row.price }} </span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="客户卖价">
          <el-table-column prop="saleAbsoluteValue" label="绝对值"> 
            <template slot-scope="scope">
              <span :class="{del: scope.row.isDel}"> {{ scope.row.buy.toString() == "NaN" || parseFloat(scope.row.buy) < 0 ?'---':scope.row.buy }} </span>
            </template>
          </el-table-column>
          <el-table-column prop="salePercentage" label="百分比"> 
            <template slot-scope="scope">
              <span :class="{del: scope.row.isDel}"> {{ conBai(scope.row.buy, scope.row.price) }} </span>
            </template>
          </el-table-column>
          <el-table-column prop="avol_percentage" label="波动度"> 
            <template slot-scope="scope">
              <span :class="{del: scope.row.isDel}"> {{ scope.row.buyVol == "NaN%" || parseFloat(scope.row.buyVol) < 0?'---':scope.row.buyVol }} </span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="客户买价" >
          <el-table-column prop="buyAbsoluteValue" label="绝对值" width="98"> 
            <template slot-scope="scope">
              <span :class="{del: scope.row.isDel}"> {{ scope.row.sale.toString() == "NaN" || parseFloat(scope.row.sale) < 0 ?'---':scope.row.sale }} </span>
            </template>
          </el-table-column>
          <el-table-column prop="buyPercentage" label="百分比" width="97"> 
            <template slot-scope="scope">
              <span :class="{del: scope.row.isDel}"> {{ conBai(scope.row.sale, scope.row.price) }} </span>
            </template>
          </el-table-column>
          <el-table-column prop="bvol_percentage" label="波动度" width="97"> 
            <template slot-scope="scope">
              <span :class="{del: scope.row.isDel}"> {{ scope.row.saleVol == "NaN%" || parseFloat(scope.row.saleVol) < 0 ?'---':scope.row.saleVol }} </span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>

    <el-row>
      <el-col :span="24" style="position: relative;background-color: white;">
        <div class="" style="float: left;height:90px;">
          <img src="../public//20180515110330.jpg" width="35%" />
        </div>
        <p
          style="padding: 0 30px;margin: 0;position: absolute;top: 10px;left: 100px;line-height: 25px;text-align:center;font-size: 14px;color: rgb(9,88,167);">
          免责声明：本报价中的信息均来自南华资本管理有限公司被认为可靠的公开资料,
          但南华资本对这些信息的完整性和可靠性不做任何保证,报告内容仅供参考,报告中的信息或所表达的意见，并不构成买卖的出价或询价,
          实时报价可参考左下方的微信报价平台。
        </p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import p from '@/public/price.min.js'
  import g from '@/components/Global.vue'
  import GlobalConfig from '@/components/Global.config.vue'
  import axios from '@/axios'
  import Jq from 'jquery'
  export default {
    name: "pdf",
    data() {
      return {
        optionsQuoteServerMarket: g.optionsQuoteServerMarket,
        // optionsQuoteServer: g.optionsQuoteServer,

        options: [{
          value: '交易所',
          label: '交易所'
        }, {
          value: '板块',
          label: '板块'
        }],
        data11: '',
        value: '交易所',
        value7: [],
        NewData: [],
        ThisTime: "",
        NowDay: "",
        OneMonthDay: "",
        NowDayCom: "",
        NumDay: "",
        rest_day: [],
        CodeList: [],
        sorting_code: [],
        MarketCode: [],
        bid_deduction: "",
        ask_deduction: "",
        festival_list: [],
        market: [{
          text: '上海期货交易所',
          value: '上海期货交易所'
        }, {
          text: '郑州商品交易所',
          value: '郑州商品交易所'
        }, {
          text: '大连商品交易所',
          value: '大连商品交易所'
        }, {
          text: '上海国际能源交易中心',
          value: '上海国际能源交易中心'
        }],
        code: [],
        loading: true,
        dialogVisible: false,
        lastTime: '',
        last: '',
        nows: Date.now(),
        jjr: [],
        
        newData: [],
        CacheData: [],
        marketCode: [],
        drawerBtn: false,
        restDay: [],
        expiryDate: '',
        minDays: '',
        nowDate: '',

        pickerOptions: {
          disabledDate: date => {
            return date.getDay() === 0 || date.getDay() === 6 || this.timeFormat(date) < this.minDays || this.$store.state.restDayStore.indexOf(Number(this.timeFormat(date))) !== -1
          }
        },

        bid_deduction: '',
        ask_deduction: '',
        CodeList: [],
        FlatVolatility: {
          'vol': false,
          'pri': false
        },
        sucOrEee: false,
        Title: 'test',
        drawerModal: false,
        direction: 'C',
        optionDirection: [{
            value: 'C',
            label: '看涨'
          },
          {
            value: 'P',
            label: '看跌'
          }
        ],
        strikePrice: 0,
        modalPrompt: false,
        detailedData: {
          code: '',
          market: '',
          interestRate: '',
          thePrice: 0,
          strikePrice: 0,
          volume: 0,
          buyPrice: 0,
          salePrice: 0,
          buyVol: '',
          saleVol: '',
          buyPercent: '',
          salePercent: '',
          tradeMinVolume: 0,
          tradeMaxVolume: 0,
          marginRate: '',
          tradingMargin: '',
          delta: '',
          royalties: '',
          margin: '',
        },
        buyLabel: '买价',
        saleLabel: '卖价',
        daochuFlag: true,
        dialogVisible: false,
        book: '',
        nameOptions: [], //获取品种名称
        productData: [],    //交易参数配置数据
        plateNameOptions: [],     //板块名称数组
        exchangeNames: ['上海期货交易所', '郑州商品交易所', '大连商品交易所', '上海国际能源交易中心', '上海黄金交易所', '中国金融期货交易所', '香港期货交易所'],

        fluctuationTimer: null,

        orderData: {},
        orderDirection: '',
        dialogOrder: false,
        tradePassword: '',

        codeList: [],
        instrumentStore: [],

        dayDiff: null,
        equalityArray: [],    //记录相同行, 用于合并行
        equalityRow: {    //记录相同行, 用于合并行
          one: 0,
          two: 0,
          three: 0,
          four: 0,
        },
        equalityFlag: {
          one: true,
          two: true,
          three: true,
          four: true,
        }
      }
    },
    created() {
      this.getProductConfig().then(() => {     //获取交易参数配置
        this.start()
      })     
      this.morningGetCurrent()  //定时在早上请求新的交易日
    },
    destroyed() {
      if (this.fluctuationTimer) {
        clearTimeout(this.fluctuationTimer)
      }
    },
    methods: {
      start() {
        this.newData = []
        this.loading = true
        this.getCurrentDate().then(nowDate => {
          this.nowDate = nowDate
          this.getRestDay().then(() => { //获取节假日
            this.getCodeList() //获取代码表
          })
        })
        this.getFestival() //节假日扣减天数
      },

      getCurrentDate() {
        return new Promise((reslove, reject) => {
          axios.get('client/inner/businessinfo/query.do').then(result => {
            let nowDate = this.dateFormat(result.data.businessInfo.tradingDay)
            reslove(nowDate)
          })
        })  
      },
      getDiff(start = this.nowDate, end = this.expiryDate, isTrade = 1) {
        return new Promise((reslove, reject) => {
          axios.post('client/forward/forwardorderlog/getDaysByTradingDayType.do', this.qs.stringify({
            staringDate: start,
            expiringDate: end,
            tradingDayType: isTrade,
          })).then(result => {
            reslove(result.data.days)
            return result.data.days
          })
        })
      },
      getProductConfig() {    //获取交易参数配置
        return new Promise((reslove, reject) => {
          axios.post("client/inner/exchangeproductconfig/queryAll.do").then(result => {
            this.productData = result.data.exchangeProductConfig
            reslove(result.data.exchangeProductConfig)
          })
        })
      },

      getDate(date) {
        // let time = this.timeyyM(nows)
        // let lastTime = this.getLast(time)
        let last = this.nextDate(date, 30)
        let week = this.timeyy(last)
        if (week == '周六') {
          last = this.nextDate(this.lastTime, 2)
        }
        if (week == '周日') {
          last = this.nextDate(this.lastTime, 1)
        }
        let week2 = this.getjjr(last)
        if (week2 == '周六') {
          last = this.nextDate(this.lastTime, 2)
        }
        if (week2 == '周日') {
          last = this.nextDate(this.lastTime, 1)
        }
        this.data11 = last
        this.start()
      },
      getjjr(str) {
        let jjr = this.jjr
        for (let i = 0; i < jjr.length; i++) {
          if (str == jjr[i]) {
            return getjjr(Number(str) + 1)
          } else {
            return str
          }
        }
      },
      // 获取下一天
      nextDate(date, num = 1) {
        // date为时间戳格式
        let time = date + 24 * 60 * 60 * 1000 * num
        var nextDate = new Date(time)
        this.lastTime = time
        return this.timeFormat(nextDate)
      },
      // 获取一个月后的今天
      getLast(date) {
        // date 格式为yyyy-mm-dd的日期
        var arr = date.split('-');
        var year = arr[0]; //获取当前日期的年份
        var month = arr[1]; //获取当前日期的月份
        var day = arr[2]; //获取当前日期的日
        var days = new Date(year, month, 0);
        days = days.getDate(); //获取当前日期中的月的天数
        var year2 = year;
        var month2 = parseInt(month) + 1;
        if (month2 == 13) {
          year2 = parseInt(year2) + 1;
          month2 = 1;
        }
        var day2 = day;
        var days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
          day2 = days2;
        }
        if (month2 < 10) {
          month2 = '0' + month2;
        }

        var t2 = year2 + '' + month2 + '' + day2;
        return t2;
      },
      // 检测时间
      getMyDay(date) {
        var week;
        if (date.getDay() == 0) week = "周日"
        if (date.getDay() == 1) week = "周一"
        if (date.getDay() == 2) week = "周二"
        if (date.getDay() == 3) week = "周三"
        if (date.getDay() == 4) week = "周四"
        if (date.getDay() == 5) week = "周五"
        if (date.getDay() == 6) week = "周六"
        return week
      },
      // 将时间戳转化为yyyyMMdd格式的时间
      timeyyM(str) {
        let time = new Date(str);
        let y = time.getFullYear().toString();
        let m = time.getMonth() + 1;
        let d = time.getDate();
        m = m.toString().padStart(2, "0")
        d = d.toString().padStart(2, "0")
        let sj = y + '-' + m + '-' + d;
        return sj
      },
      
      changePlate: function (ele) {
        if (ele == "交易所") {
          for (var j = 0; j < this.newData.length; j++) {
            switch (this.newData[j].market) {
              case "SHFE":
                this.newData[j].CN_name = "上海期货交易所";
                break;
              case "DCE":
                this.newData[j].CN_name = "大连商品交易所";
                break;
              case "CZCE":
                this.newData[j].CN_name = "郑州商品交易所";
                break;
              case "INE":
                this.newData[j].CN_name = "上海国际能源交易中心";
                break;
              case "SGE":
                this.newData[j].CN_name = "上海黄金交易所";
                break;
              case "CFFEX":
                this.newData[j].CN_name = "中国金融期货交易所";
                break;
              case "HKFE":
                this.newData[j].CN_name = "香港期货交易所";
                break;
              default: 
                this.newData[j].CN_name = this.newData[j].market;
            }
          }
          this.newData.sort(p.by('CN_name', p.by('code')));
          this.newData.reverse()
          this.comCell()
          this.market = [{
            text: '上海期货交易所',
            value: '上海期货交易所'
          }, {
            text: '郑州商品交易所',
            value: '郑州商品交易所'
          }, {
            text: '大连商品交易所',
            value: '大连商品交易所'
          }, {
            text: '上海国际能源交易中心',
            value: '上海国际能源交易中心'
          }, {
            text: '上海黄金交易所',
            value: '上海黄金交易所'
          }, {
            text: '中国金融期货交易所',
            value: '中国金融期货交易所'
          }, {
            text: '香港期货交易所',
            value: '香港期货交易所'
          },]
        } else if (ele == "板块") {
           for (let i = 0; i < this.newData.length; i++) {
             this.newData[i].CN_name = this.newData[i].plateName
           }
          this.newData.sort(p.by('CN_name', p.by('code')));
          this.newData.reverse()
          this.comCell()
        } else {

        }
      },
      regDate() {

      },

      downPdf: function () {
        document.title = 'NhCapital' + this.nowDate;
        document.getElementById("dpdf").style.display = "none";
        window.print();
        document.title = 'NhCapital'
        document.getElementById("dpdf").style.display = "block";
      },
      downExcel() {
        let type = this.value === '板块' ? 1 : 0

        let msg = this.newData.map(item => {
          let peType = this.getPeType(item, type)
          let peName = item.CN_name 
          let product = item.name
          let instrument = item.code
          let price = item.price
          let sellPriceAbs = this.conformToRules(item.buy)
          let sellPricePercentage = this.conBai(item.buy, item.price)
          let sellPriceVolatility = this.conformToRules(item.buyVol)
          let buyPriceAbs = this.conformToRules(item.sale)
          let buyPricePercentage = this.conBai(item.sale, item.price)
          let buyPriceVolatility = this.conformToRules(item.saleVol)
          let isDel = item.isDel ? 1 : 0
          return { peType, peName, product, instrument, price, sellPriceAbs, sellPricePercentage, sellPriceVolatility, buyPriceAbs, buyPricePercentage, buyPriceVolatility, isDel }
        })
        let data = {
          qus: msg,
          quoteDate: this.nowDate,
          expirDate:this.expiryDate,
          type,
        }
        data = {qijsonStr: JSON.stringify(data)}
        let ajaxurl = g.baseURL
        // let ajaxurl = 'https://biz.nanhuacapital.com/d_196/'
        this.postDown(ajaxurl + 'client/inner/quote/exportQuoteInfo.do', data, Jq)
      },
      postDown(url, data, $) {
        let form = $("<form>"); //创建form标签
        form.attr("style", "display:none");
        form.attr("method", "post"); //设置请求方式
        form.attr("target", "_blank")
        form.attr("charset", "UTF-8")
        form.attr("enctype", "application/json")

        form.attr("action", url); //action属性设置请求路径
        $("body").append(form); //页面添加form标签

        for (let item in data) {
          if (Array.isArray(data[item])) {
            data[item].forEach(list => {
              let input1 = $("<input>") //创建input标签
              input1.attr("type", "hidden") //设置隐藏域
              input1.attr("name", item + '[]') //设置发送后台数据的参数名
              input1.attr("value", list);
              form.append(input1);
            })
          } else {
            let input1 = $("<input>") //创建input标签
            input1.attr("type", "hidden") //设置隐藏域
            input1.attr("name", item) //设置发送后台数据的参数名
            input1.attr("value", data[item]);
            form.append(input1);
          }
        }
        form.submit(); //表单提交即可下载
      },
      getPeType(item, type) {
        let pe = -1
        if(type) {
          switch(item.plateName) {
            case '黑色':
              pe = 101
              break;
            case '能化':
              pe = 102
              break;
            case '有色':
              pe = 103
              break;
            case '贵金属':
              pe = 104
              break;
            case '农产品':
              pe = 105
              break;
            case '商品ETF':
              pe = 106
              break;
            case '个股':
              pe = 107
              break;
            case '股指':
              pe = 108
              break;
            case '基金':
              pe = 109
              break;
            case 'LIBOR':
              pe = 110
              break;
            case 'LPR':
              pe = 111
              break;
            case '地方政府债':
              pe = 112
              break;
            case '国股银票转贴现':
              pe = 113
              break;
            case '国债':
              pe = 114
              break;
            case '政策性金融债':
              pe = 115
              break;
            case '美元兑人民币':
              pe = 116
              break;
            case '公司债':
              pe = 117
              break;
            case '金融债':
              pe = 118
              break;
            default:
              break;
          }
        } else {
          let market = item.market.toUpperCase()
          switch(market) {
            case 'CZCE':
              pe = 1
              break;
            case 'DCE':
              pe = 2
              break;
            case 'SHFE':
              pe = 3
              break;
            case 'INE':
              pe = 4
              break;
            case 'SGE':
              pe = 5
              break;
            case 'CFFEX':
              pe = 6
              break;
            case 'HKFE':
              pe = 7
              break;
            default:
              break;
          }
        }
        return pe
      },
      conformToRules(val) {
        return val.toString() == "NaN" || parseFloat(val) < 0 ? -1 : val
      },

      getRowClass({row, rowIndex}) {
        if(row.CN_name == '未配置板块名') {
          return 'color5-even'
        } else if (row.CN_name == "上海期货交易所" && rowIndex % 2 === 0 || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 1  && rowIndex % 2 === 0) {
          return 'color1-even'
        } else if (row.CN_name == "上海期货交易所" && rowIndex % 2 === 1 ||(this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 1  && rowIndex % 2 === 1) {
          return 'color1-odd'
        } else if (row.CN_name == "郑州商品交易所" && rowIndex % 2 === 0 || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 2  && rowIndex % 2 === 0) {
          return 'color2-even'
        } else if (row.CN_name == "郑州商品交易所" && rowIndex % 2 === 1 || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 2  && rowIndex % 2 === 1) {
          return 'color2-odd'
        } else if (row.CN_name == "大连商品交易所" && rowIndex % 2 === 0 || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 3  && rowIndex % 2 === 0) {
          return 'color3-even'
        } else if (row.CN_name == "大连商品交易所" && rowIndex % 2 === 1 || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 3  && rowIndex % 2 === 1) {
          return 'color3-odd'
        } else if(row.CN_name == "上海国际能源交易中心" && rowIndex % 2 === 0 || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 0 && rowIndex % 2 === 0) {
          return 'color4-even'
        } else if(row.CN_name == "上海国际能源交易中心" && rowIndex % 2 === 1 || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 0 && rowIndex % 2 === 1) {
          return 'color4-odd'
        } else if (row.CN_name == "上海黄金交易所" && rowIndex % 2 === 0 || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 1  && rowIndex % 2 === 0) {
          return 'color1-even'
        } else if (row.CN_name == "上海黄金交易所" && rowIndex % 2 === 1 ||(this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 1  && rowIndex % 2 === 1) {
          return 'color1-odd'
        } else if (row.CN_name == "中国金融期货交易所" && rowIndex % 2 === 0 || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 2  && rowIndex % 2 === 0) {
          return 'color2-even'
        } else if (row.CN_name == "中国金融期货交易所" && rowIndex % 2 === 1 || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 2  && rowIndex % 2 === 1) {
          return 'color2-odd'
        } else if (row.CN_name == "香港期货交易所" && rowIndex % 2 === 0 || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 3  && rowIndex % 2 === 0) {
          return 'color3-even'
        } else if (row.CN_name == "香港期货交易所" && rowIndex % 2 === 1 || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 3  && rowIndex % 2 === 1) {
          return 'color3-odd'
        }else {
          return 'color5-even'
        }
        // else if(row.CN_name == "未配置板块名" && rowIndex % 2 === 0){
        //   return 'color5-even'
        // } else if(row.CN_name == "未配置板块名" && rowIndex % 2 === 1) {
        //   return 'color5-odd'
        // }
      },
      filterHandler(value, row, column) {
        const property = column['property'];
        return row[property] === value;
      },

      getCodeList() { //替换websocket的代码表请求
        axios.get("client/inner/quoteconfig/queryTradeAll.do").then(result => {
          let list = result.data.quoteConfigs
          let codeList = []
          this.newData = []
          let plateNameOptions = []   //板块名称数组
          list.forEach(item => {
            let plateName = ''
            this.productData.forEach(list => {
              let num = item.instrument.replace(/[^0-9]/ig,"")
              let index = item.instrument.indexOf(num)
              let product = item.instrument.substring(0, index)
              product = product.toLowerCase()
              let listProduct = list.product.toLowerCase()
              if(list.exchange == item.exchange && listProduct == product) {
                plateName = list.plateName
              }
            })
            let obj = {
              id: item.id,
              market: item.exchange,
              code: item.instrument,
              deadline: this.timeFormat(new Date(Number(item.deadline))),
              interest_rate: item.interestRate,
              min_days: item.minDays,
              strike_price_change: item.strikePriceChange,
              strike_price_count: item.strikePriceCount,
              trade_max_volume: item.tradeMaxVolume,
              trade_min_volume: item.tradeMinVolume,
              marginType: item.marginType,
              marginRate: item.marginRate,
              specialMarginRate: item.specialMarginRate,    //特别保证金率
              yearSession: item.yearTradeDays,
              // buyCpsDays: item.askCompensateDay,       //方向不同反过来取
              // sellCpsDays: item.bidCompensateDay,      
              buyCpsDays: item.bidCompensateDay,
              sellCpsDays: item.askCompensateDay,
              subAccountNo: item.subAccountNo,
              name: item.productName,
              quoteEffectiveDate: item.quoteEffectiveDate,    //报价有效期
              priceAccuracy: item.priceAccuracy,    //期权价格精度
              plateName: plateName == '' ? '未配置板块名' : plateName,     //板块名称
            }
            plateNameOptions.push(obj.plateName)
            
            codeList.push(obj)
          })
          plateNameOptions.unshift('农产品', '有色与贵金属', '能源化工', '黑色产业')
          this.plateNameOptions = [...new Set(plateNameOptions)]

          this.$store.dispatch('changeCodeList', codeList)
          let minDaysArr = []
          let arr = []
          
          for (let i = 0; i < codeList.length; i++) {
            let obj = {}
            obj['market'] = codeList[i].market
            obj['code'] = codeList[i].code
            arr.push(obj)
            let newObj = {}
            newObj['id'] = codeList[i].id
            newObj['product_id'] = ''
            newObj['market'] = codeList[i].market
            newObj['code'] = codeList[i].code
            newObj['name'] = codeList[i].name
            newObj['price'] = '--'
            newObj['buy'] = '--'
            newObj['sale'] = '--'
            newObj['strike_price_change'] = codeList[i].strike_price_change
            newObj['ask_volatility'] = ''
            newObj['bid_volatility'] = ''
            newObj['interest_rate'] = codeList[i].interest_rate
            newObj['marginType'] = codeList[i].marginType
            newObj['marginRate'] = codeList[i].marginRate
            newObj['specialMarginRate'] = codeList[i].specialMarginRate
            // 新增年交易日数计算和买卖补偿天数、子账、保证金类型、品种名称、特别保证金率
            newObj["yearSession"] = codeList[i].yearSession ? codeList[i].yearSession : 365 //年交易日数为0时为365天
            newObj["buyCpsDays"] = codeList[i].buyCpsDays ? codeList[i].buyCpsDays : 0 //买补偿天数      
            newObj["sellCpsDays"] = codeList[i].sellCpsDays ? codeList[i].sellCpsDays : 0 //卖补偿天数
            newObj["subAccountNo"] = codeList[i].subAccountNo
            newObj["quoteEffectiveDate"] = codeList[i].quoteEffectiveDate   //获取报价有效期
            newObj["priceAccuracy"] = codeList[i].priceAccuracy   //期权价格精度
            newObj["plateName"] = codeList[i].plateName
            // newObj["CN_name"] = this.changeMarket(codeList[i].market)
            newObj["CN_name"] = newObj["plateName"]
            

            // 检测报价有效期是否过期, 过期显示中间穿过线
            let current = new Date(Number(this.timeFormat(new Date(codeList[i].quoteEffectiveDate)))).getTime()
            let now = new Date(Number(this.nowDate)).getTime()
            if(current < now) {
              newObj["isDel"] = true 
            } else {
              newObj["isDel"] = false
            }

            // if (Math.floor(Math.random() * 2) === 0) {
            //   newObj['call'] = true
            //   newObj['put'] = false
            // } else {
            //   newObj['call'] = false
            //   newObj['put'] = true
            // }
            minDaysArr.push(codeList[i].min_days)
            this.newData.push(newObj)
          }
          this.value = '板块'
          this.changePlate('板块')
          // this.newData.sort(p.by('CN_name', p.by('code')));
          // this.newData.reverse()
          // this.comCell()
          let _this = this
          let that = this
          // 声明公共函数

          function OptionsQuoteSessionCodeList(url) {
            let _this = this
            this.out_going_queue = []
            this.connection = null
            this.is_open = function () {
              return this.connection.readyState === WebSocket.OPEN
            }
            this.send = function (parcel) {
              let data = JSON.stringify(parcel)
              if (this.is_open()) {
                this.connection.send(data)
                return true
              } else {
                return false
              }
            }
            this.flush = function () {}

            function onOpen(evt) {
              _this.codeinfo()
              _this.jichushujv()
              _this.dingyue()
            }

            function onClose(evt) {
              setTimeout(function () {
                _this.reconnect()
              }, 10000)
            }

            function onError(evt) {}

            function heartbeat() {
              setInterval(() => {
                if(_this.connection.readyState !== 1) return
                _this.connection.send(JSON.stringify({messageType: "HEARTBEAT"}))
              }, 50000)
              
            }

            this.reconnect = function () {
              this.connection = new WebSocket(url)
              this.connection.onopen = onOpen
              this.connection.onclose = onClose
              this.connection.onmessage = onMessage
              this.connection.onerror = onError
            }
            this.codeinfo = function () {     //代码表
              let queryCodeInfoReqPack = makeParcel(GlobalConfig.optionType.request.requestCodeInfo, {
                'code_list': that.marketCode
              })
              if (!this.send(queryCodeInfoReqPack)) {
                return false
              }
            }
            this.jichushujv = function () {     //初始化行情
              let queryCodeInfoReqPack = makeParcel(GlobalConfig.optionType.request.requestMarket, {
                'code_list': that.marketCode
              })
              if (!this.send(queryCodeInfoReqPack)) {
                return false
              }
            }
            this.dingyue = function () {      //行情推送
              let queryCodeInfoReqPack = makeParcel(GlobalConfig.optionType.push.pushMarket, {
                'code_list': that.marketCode
              })
              if (!this.send(queryCodeInfoReqPack)) {
                return false
              }
            }

            // function onMessage(evt) {
            //   let parcel = JSON.parse(evt.data)
            //   switch (parcel.f) {
            //     case optionsQuote.kOutQueryHangQingResp: //获取行情相关
            //       that.CacheData = JSON.parse(evt.data).b.market_data
            //       that.$store.dispatch('changeCacnhe', that.CacheData)
            //       that.FlatVolatility.pri = true
            //       that.sucOrEee = true
            //       for (let i = 0; i < that.newData.length; i++) {
            //         for(let j=0;j<parcel.b.market_data.length; j++) {
            //           if(that.newData[i].market == parcel.b.market_data[j].exchange_id && that.newData[i].code == parcel.b.market_data[j].instrument_id) {
            //             let newPrice = parcel.b.market_data[j].last_price?parcel.b.market_data[j].last_price:parcel.b.market_data[j].pre_close_price
            //             let priceAccuracy = that.newData[i].priceAccuracy
            //             that.newData[i].price = Number(newPrice.toFixed(priceAccuracy))
            //           }
            //         }
            //       }
            //       break
            //     case optionsQuote.kOutQueryDingYueResp:
            //       let ThisData = JSON.parse(evt.data)
            //       for (let j = 0; j < that.CacheData.length; j++) {
            //         if (that.CacheData[j].instrument_id === ThisData.b.market_data[0].instrument_id) {
            //           let newPrice = ThisData.b.market_data[0].last_price?ThisData.b.market_data[0].last_price:ThisData.b.market_data[0].pre_close_price
            //           that.CacheData[j].last_price = Number(newPrice.toFixed(2))
            //         }
            //       }
            //       that.$store.dispatch('changeCacnhe', that.CacheData)
            //       break
            //     case optionsQuote.kOutQueryMarketCodeResp:
            //       let data = JSON.parse(evt.data).b.instrument
            //       for (let i = 0; i < that.newData.length; i++) {
            //         for(let j = 0; j < data.length; j++) {
            //           if(that.newData[i].code == data[j].instrument_id && that.newData[i].market == data[j].exchange_id) {
            //             that.newData[i].product_id = data[j].product_id
            //           }
            //         }
            //       }
            //       that.$store.dispatch('changeInstrument', parcel.b.instrument)
            //       break
            //     default:
            //       break
            //   }
            // }
            function onMessage(evt) {
              let parcel = JSON.parse(evt.data)
              switch (parcel.messageType) {
                case GlobalConfig.optionType.response.initMarket:          //获取初始化行情相关
                  heartbeat()
                  that.CacheData = JSON.parse(evt.data).messageData.market_data
                  that.$store.dispatch('changeCacnhe', that.CacheData)
                  that.FlatVolatility.pri = true
                  that.sucOrEee = true
                  for (let i = 0; i < that.newData.length; i++) {
                    for(let j=0;j<parcel.messageData.market_data.length; j++) {
                      if(that.newData[i].market == parcel.messageData.market_data[j].exchange_id && that.newData[i].code == parcel.messageData.market_data[j].instrument_id) {
                        let newPrice = parcel.messageData.market_data[j].last_price?parcel.messageData.market_data[j].last_price:parcel.messageData.market_data[j].pre_close_price
                        let settlePrice = parcel.messageData.market_data[j].settlePrice?parcel.messageData.market_data[j].settlePrice:parcel.messageData.market_data[j].pre_close_price
                        let priceAccuracy = that.newData[i].priceAccuracy
                        that.newData[i].price = Number(newPrice.toFixed(priceAccuracy))
                        that.newData[i].preSettlePrice = Number(settlePrice.toFixed(priceAccuracy))
                      }
                    }
                  }
                  break
                case GlobalConfig.optionType.response.pushType:         //获取行情推送
                  let ThisData = JSON.parse(evt.data)
                  for (let j = 0; j < that.CacheData.length; j++) {
                    if (that.CacheData[j].instrument_id === ThisData.messageData.market_data[0].instrument_id) {
                      let newPrice = ThisData.messageData.market_data[0].last_price?ThisData.messageData.market_data[0].last_price:ThisData.messageData.market_data[0].pre_close_price
                      that.CacheData[j].last_price = Number(newPrice.toFixed(2))
                    }
                  }
                  that.$store.dispatch('changeCacnhe', that.CacheData)
                  break
                case GlobalConfig.optionType.response.initCodeInfo:        //获取代码表
                  let data = JSON.parse(evt.data).messageData.instrument
                  for (let i = 0; i < that.newData.length; i++) {
                    for(let j = 0; j < data.length; j++) {
                      if(that.newData[i].code == data[j].instrument_id && that.newData[i].market == data[j].exchange_id) {
                        that.newData[i].product_id = data[j].product_id
                      }
                    }
                  }
                  that.$store.dispatch('changeInstrument', parcel.messageData.instrument)
                  break
                default:
                  break
              }
              that.getNewPriceFun()
            }
          }

          function Parcel(msgType, body) {
            this.messageType = msgType
            if (body) {
              this.messageData = body
            } else {
              this.b = {}
            }
          }

          function makeParcel(msgType, body) {
            let p = new Parcel(msgType, body)
            return p
          }
          let optionsQuote = {
            'kOutQueryCodeInfoReq': 257,
            'kOutQueryCodeInfoResp': 33025,
            'kOutQueryVolatilityReq': 265,
            'kOutQueryVolatilityResp': 33033,
            'kOutQueryFestivalReq': 259,
            'kOutQueryFestivalResp': 33027,
            'kOutQueryTradingDayReq': 260,
            'kOutQueryTradingDayResp': 33028,
            'kOutQueryMarketCodeReq': 513,
            'kOutQueryMarketCodeResp': 33281,
            'kOutQueryHangQingReq': 514,
            'kOutQueryHangQingResp': 33282,
            'kOutQueryDingYueReq': 515,
            'kOutQueryDingYueResp': 33283
          }
          this.marketCode = arr
          let mindays = Math.min.apply(Math, minDaysArr)
          let DayArr = this.ThirdDate(this.restDay, 30)
          this.expiryDate = DayArr[0]
          // this.nowDate = DayArr[2]
          let DayArrMin = this.ThirdDate(this.restDay, mindays)
          this.minDays = DayArrMin[0]
          let locaOpArr = JSON.parse(localStorage.getItem('optionalCode')) || []
          for (var i = 0; i < locaOpArr.length; i++) {
            if (locaOpArr[i].opExpiryDate < this.expiryDate) {
              locaOpArr.splice(i, 1)
              i--
            } else {}
          }

          this.getDiff().then(day => {
            this.dayDiff = day
            this.fluctuation() //获取波动度
          })
          this.loading = false

          let optionsQuoteServerMarket = g.optionsQuoteServerMarket
          // let optionsQuoteServer = g.optionsQuoteServer
          localStorage.setItem('optionalCode', JSON.stringify(locaOpArr))
          this.$store.dispatch('changeOptional', locaOpArr)

          let optionsQuoteSesseionJichu = new OptionsQuoteSessionCodeList(optionsQuoteServerMarket)
          optionsQuoteSesseionJichu.reconnect()
          // let optionsQuoteSesseion = new OptionsQuoteSession(optionsQuoteServer)
          // optionsQuoteSesseion.reconnect()


          //  每过3秒刷新一次最新报价
          setInterval(() => {
            if (this.FlatVolatility.vol && this.FlatVolatility.pri) {
              this.FlatVolatility.vol = false
              this.$Loading.finish()
              return false
            }
            this.getNewPriceFun()
          }, 5000)
        })
      },

      getRestDay() { //获取节假日
        return new Promise((reslove, reject) => {
          axios.get("client/inner/festivalconfig/queryFestivalList.do").then(result => {
            let restDays = JSON.parse(result.data.festivalConfig).exchange_rest_day[0].rest_day
            this.restDay = restDays
            reslove()
          })
        })
      },
      getFestival() { //节假日扣减天数
        return new Promise((reslove, reject) => {
          axios.get("client/inner/festivalconfig/queryAll.do").then(result => {
            if (result.data.success) {
              let data = result.data.festivalConfigs
              let arr = []
              data.forEach(item => {
                let obj = {
                  ask_deduction: item.askDeduction,
                  bid_deduction: item.bidDeduction,
                  business_type: item.businessType,
                  festival_date: this.timeFormat(new Date(item.festivalDate)),
                  id: item.id,
                }
                arr.push(obj)
              })
              this.festivalList = arr

              let dce = this.Deduction(this.timeFormat(), this.expiryDate, this.festivalList)
              this.bid_deduction = dce[0]
              this.ask_deduction = dce[1]
            }
          })
        })
      },
      fluctuation() { //获取全部波动度
        
        return new Promise((reslove, reject) => {
          axios.post("client/inner/quoteconfig/getTradeVolatilityVOList.do", this.qs.stringify({
            expiringDate: this.expiryDate,
          })).then(result => {
            this.loading = false
            if (result.data.success) {
              let data = result.data.tvs
              this.FlatVolatility.vol = true
              this.sucOrEee = true
              for(let i = 0; i < this.newData.length; i++) {
                for (let j = 0; j < data.length; j++) {
                  if(data[j].exchange == this.newData[i].market && data[j].underlying == this.newData[i].code) {
                    this.newData[i].ask_volatility = data[j].askVolatility
                    this.newData[i].bid_volatility = data[j].bidVolatility
                    
                    this.newData[i].saleVol = this.mul(this.newData[i].bid_volatility, 100).toFixed(3) + '%'
                    this.newData[i].buyVol = this.mul(this.newData[i].ask_volatility, 100).toFixed(3) + '%'
                  }
                  
                }
              }
              
              reslove()
              this.fluctuationTimer = setTimeout(() => {
                this.fluctuation()
              }, 300000);
              setTimeout(() => {
                this.getNewPriceFun()
              }, 1000)
              
            }
          }, (err) => {
            this.loading = false
          })
        })
      },
      fluctuationOnlyOne(exchange, underlying, expiringDate, lastPrice, strikePrice, subAccountNo) { //获取单个的买卖波动度
        return new Promise((reslove, reject) => {
          axios.post("client/inner/quoteconfig/getTradeVolatilityVO.do", this.qs.stringify({
            exchange,
            underlying,
            lastPrice,
            strikePrice,
            expiringDate,
            subAccountNo,
          })).then(result => {
            if (result.data.success) {
              reslove(result.data.tradeVolatilityVO)
            } else {
              reslove([])
            }
          })
        })
      },

      handleStart() {
        this.$Modal.info({
          title: 'Bravo',
          content: 'Now, enjoy the convenience of iView.'
        })
      },
      bottom() {

      },
      expiryDateChange () {
        // let dce = this.Deduction(this.nowDate, this.expiryDate, this.festivalList)
        // this.bid_deduction = dce[0]
        // this.ask_deduction = dce[1]
        // let arr = []
        // for (let i = 0; i < this.newData.length; i++) {
        //   let obj = {}
        //   obj['market'] = this.newData[i].market
        //   obj['code'] = this.newData[i].code
        //   obj['expiring_date'] = this.changeDate(this.expiryDate)
        //   obj['strike_price_ratio'] = [1]
        //   arr.push(obj)
        // }
        // this.NumDay = p.DateDiff(this.nowDate, this.expiryDate)
        this.loading = true
        this.getDiff().then(day => {
          this.dayDiff = day
          this.fluctuation()
        })
        
        // let websockObj = {}
        // websockObj['f'] = 265
        // websockObj['r'] = this.generateRid()
        // websockObj['b'] = {}
        // websockObj.b['query_list'] = arr
        // let that = this
        // that.websock.send(JSON.stringify(websockObj))
        // that.websock.onmessage = function (evt) {
        //   let parcel = JSON.parse(evt.data)
        //   for (let j = 0; j < parcel.b.volatility_list.length; j++) {
        //     if (parcel.b.ret === 0) {
        //       that.newData[j].ask_volatility = parcel.b.volatility_list[j].ask_volatility[0]
        //       that.newData[j].bid_volatility = parcel.b.volatility_list[j].bid_volatility[0]
        //     } else {
        //       that.newData[j].ask_volatility = ''
        //       that.newData[j].bid_volatility = ''
        //     }
        //   }
        //   that.getNewPriceFun()
        // }
      },
      detailedPrice: function (c, p, isDel, expiryDate, msg) {   //tBus代表是否是Tpage界面传过来的值, 默认为undefind
        return new Promise((reslove, reject) => {
          if(p == 'NaN' || p == 'NaN%' || p == '0.00%' || p == '---' || p <= 0) return
          if(isDel) {
            this.$Message.warning("所有带有删除线的报价证明该报价还未进行确认")
            return
          }
          let direction = msg?msg.direction:'C'
          let marginRate = 0
          let marginType = 4
          let specialMarginRate = 0
          this.direction = direction
          for (var i = 0; i < this.newData.length; i++) {
            if (c === this.newData[i].code) {
              this.currentRow = this.newData[i]
              if (this.newData[i].buy === '---') {
                return false
              }
              // salePrice
              if(this.newData[i].yearSession == 0 || this.newData[i].yearSession == 365) {
                var dateNum = this.DateDiff(this.nowDate, this.changeDate(expiryDate), this.newData[i].buyCpsDays, this.newData[i].sellCpsDays)
              } else {
                if(!this.dayDiff) {
                  this.getDiff().then(day => {
                    var dateNum = [day + this.newData[i].buyCpsDays, day + this.newData[i].sellCpsDays]
                  })
                } else {
                  var dateNum = [this.dayDiff + this.newData[i].buyCpsDays, this.dayDiff + this.newData[i].sellCpsDays]
                }
              }
              let bidDeduction = this.bid_deduction
              let askDeduction = this.ask_deduction

              if(this.newData[i].yearSession == 365 || this.newData[i].yearSession == 0) {
                var dtBuy = this.division(this.sub(dateNum[0], bidDeduction), 365)
                var dtSale = this.division(this.sub(dateNum[1], askDeduction), 365)
              } else {
                var dtBuy = this.division(dateNum[0], this.newData[i].yearSession)
                var dtSale = this.division(dateNum[1], this.newData[i].yearSession)
              }

              marginRate = this.newData[i].marginRate
              marginType = this.newData[i].marginType
              specialMarginRate = this.newData[i].specialMarginRate
              let priceAccuracy = this.newData[i].priceAccuracy

              this.detailedData.code = c
              this.detailedData.market = this.newData[i].market
              this.detailedData.interestRate = this.newData[i].interest_rate
              this.detailedData.thePrice = this.newData[i].price
              this.detailedData.strikePrice = msg?msg.strikePrice:this.newData[i].price
              this.detailedData.buyVol = this.newData[i].bid_volatility
              this.detailedData.saleVol = this.newData[i].ask_volatility
              
              this.detailedData.salePrice = this.CalcCall(this.newData[i].price, this.newData[i].bid_volatility, this.newData[i].interest_rate, this.newData[i].price, dtBuy).toFixed(priceAccuracy)
              this.detailedData.buyPrice = this.CalcCall(this.newData[i].price, this.newData[i].ask_volatility, this.newData[i].interest_rate, this.newData[i].price, dtSale).toFixed(priceAccuracy)
              // this.detailedData.salePrice = this.CalcCall(this.newData[i].price, this.newData[i].bid_volatility, this.newData[i].interest_rate, this.detailedData.strikePrice, dtBuy).toFixed(2)
              // this.detailedData.buyPrice = this.CalcCall(this.newData[i].price, this.newData[i].ask_volatility, this.newData[i].interest_rate, this.detailedData.strikePrice, dtSale).toFixed(2)

              this.detailedData.buyPercent = this.mul(this.division(this.detailedData.buyPrice, this.newData[i].price), 100).toFixed(3) + '%'
              this.detailedData.salePercent = this.mul(this.division(this.detailedData.salePrice, this.newData[i].price), 100).toFixed(3) + '%'
              
              // this.detailedData.buyVol = this.newData[i].ask_volatility
              // this.detailedData.saleVol = this.newData[i].bid_volatility

              this.detailedData.volume = this.$store.state.codeListStore[i].trade_min_volume
              this.detailedData.tradeMinVolume = this.$store.state.codeListStore[i].trade_min_volume
              this.detailedData.tradeMaxVolume = this.$store.state.codeListStore[i].trade_max_volume
              this.detailedData.marginRate = this.$store.state.codeListStore[i].marginRate
              // 新增年交易日数和买卖补偿天数
              this.detailedData.yearSession = this.newData[i].yearSession
              this.detailedData.buyCpsDays = this.newData[i].buyCpsDays
              this.detailedData.sellCpsDays = this.newData[i].sellCpsDays
              this.detailedData.subAccountNo = this.newData[i].subAccountNo
              this.Title = this.newData[i].code + direction + this.changeDate(expiryDate) + 'M' + this.detailedData.strikePrice
              if(!msg || !msg.from) {
                this.drawerModal = true
              }
            }
          }

          this.detailedData.tradingMargin = this.mul(this.detailedData.thePrice, this.detailedData.volume)
          this.detailedData.tradingMargin = this.mul(this.detailedData.tradingMargin, this.detailedData.marginRate)
          this.detailedData.delta = this.CalcCallDelta(this.detailedData.thePrice, this.detailedData.saleVol, 0.06, this.detailedData.strikePrice, dtSale)
          this.detailedData.delta = this.detailedData.delta.toFixed(6)

          var VirtualValue = Math.max(this.sub(this.detailedData.thePrice, this.detailedData.strikePrice), 0),
            VirtualValue = this.mul(VirtualValue, this.detailedData.volume);

          this.detailedData.royalties = this.mul(this.detailedData.salePrice, this.detailedData.volume)
          // this.detailedData.margin = this.mul(this.detailedData.tradingMargin, Math.max(this.detailedData.delta, 0.2))
          // this.detailedData.margin = Math.max(this.sub(this.detailedData.tradingMargin, (this.mul(0.5, VirtualValue))),
          //   (this.mul(0.5, VirtualValue)));
          this.detailedData.margin = this.calcMargin(this.detailedData.thePrice, this.detailedData.strikePrice, this.detailedData.salePrice, this.detailedData.volume, marginRate, specialMarginRate, marginType, direction, this.detailedData.delta)
          reslove()
        })

      },

      priceChange(data) {
        return new Promise((reslove, reject) => {
          this.Title = this.detailedData.code + this.direction + this.changeDate(this.expiryDate) + 'M' + this.detailedData.strikePrice
          if (this.detailedData.strikePrice === '---') {
            return false
          }
          // 交易日报价不扣减, 补偿天数都要补偿
          if(data.yearSession == 0 || data.yearSession == 365) {
            var dateNum = this.DateDiff(this.nowDate, this.changeDate(this.expiryDate), data.buyCpsDays, data.sellCpsDays)
          } else {
            if(!this.dayDiff) {
              this.getDiff().then(day => {
                var dateNum = [day + data.buyCpsDays, day + data.sellCpsDays]
              })
            } else {
              var dateNum = [this.dayDiff + data.buyCpsDays, this.dayDiff + data.sellCpsDays]
            }
          }
          
          let bidDeduction = this.bid_deduction
          let askDeduction = this.ask_deduction

          if(data.yearSession == 365 || data.yearSession == 0) {
            var dtBuy = this.division(this.sub(dateNum[0], bidDeduction), 365)
            var dtSale = this.division(this.sub(dateNum[1], askDeduction), 365)
          } else {
            var dtBuy = this.division(dateNum[0], data.yearSession)
            var dtSale = this.division(dateNum[1], data.yearSession)
          }
          
          this.detailedData.tradingMargin = this.mul(this.detailedData.thePrice, this.detailedData.volume)
          this.detailedData.tradingMargin = this.mul(this.detailedData.tradingMargin, this.detailedData.marginRate)
          let strikePriceRatio = []
          let spr = Number(this.division(this.detailedData.strikePrice, this.detailedData.thePrice).toFixed(8))
          strikePriceRatio.push(spr)
          let that = this 
          let arr = []
          let obj = {}
          obj['market'] = that.detailedData.market
          obj['code'] = that.detailedData.code
          obj['expiring_date'] = that.changeDate(that.expiryDate)
          obj['strike_price_ratio'] = strikePriceRatio
          arr.push(obj)
          // let websockObj = {}
          // websockObj['f'] = 265
          // websockObj['r'] = that.generateRid()
          // websockObj['b'] = {}
          // websockObj.b['query_list'] = arr

          // that.websock.send(JSON.stringify(websockObj))
          // that.websock.onmessage = function (evt) {
          //   if (JSON.parse(evt.data).b.ret !== 0) {
          //     return false
          //   }
          var volatilityList = [] //买卖波动度
          // 所需参数交易所，标的代码，到期日，标的价格，执行价
          if(!this.detailedData.strikePrice || this.detailedData.strikePrice <= 0) {
            this.$message({
              type:'error',
              message: '执行价不能为空, 且必须大于0',
              showClose: true,
            })
            this.isTrade = false   //用于设置该数据不合规, 不能进行下单操作
            return
          }
          
          this.fluctuationOnlyOne(obj.market, obj.code, obj.expiring_date, this.detailedData.thePrice, this.detailedData.strikePrice, this.detailedData.subAccountNo).then((result => {
            this.isTrade = true
            let obj = {
              ask_volatility: [result.askVolatility],
              bid_volatility: [result.bidVolatility],
              code: result.underlying,
              expiring_date: result.expiringDate,
              market: result.exchange,
            }
            volatilityList = [obj]

            if (volatilityList[0].ask_volatility[0] === 0) {
              that.detailedData.salePrice = '---'
              that.detailedData.buyPrice = '---'
              that.detailedData.buyPercent = '---%'
              that.detailedData.salePercent = '---%'
              that.detailedData.royalties = '---'
              that.detailedData.margin = '---'
              that.detailedData.buyVol = '---'
              that.detailedData.saleVol = '---'
              return false
            }

            let askVolatility = volatilityList[0].ask_volatility[0]
            let bidVolatility = volatilityList[0].bid_volatility[0]
            
            if (that.direction === 'C') {
              that.detailedData.salePrice = that.CalcCall(that.detailedData.thePrice, bidVolatility, that.detailedData.interestRate, that.detailedData.strikePrice, dtBuy).toFixed(3)
              that.detailedData.buyPrice = that.CalcCall(that.detailedData.thePrice, askVolatility, that.detailedData.interestRate, that.detailedData.strikePrice, dtSale).toFixed(3)
              that.detailedData.delta = that.CalcCallDelta(that.detailedData.thePrice, askVolatility, that.detailedData.interestRate, that.detailedData.strikePrice, dtSale)
              that.detailedData.delta = that.detailedData.delta.toFixed(6)


              var VirtualValue = Math.max(that.sub(that.detailedData.thePrice, that.detailedData.strikePrice), 0),
                VirtualValue = that.mul(VirtualValue, that.detailedData.volume);
            } else {
              that.detailedData.salePrice = that.CalcPut(that.detailedData.thePrice, bidVolatility, that
                .detailedData
                .interestRate, that.detailedData.strikePrice, dtBuy).toFixed(3)
              that.detailedData.buyPrice = that.CalcPut(that.detailedData.thePrice, askVolatility, that.detailedData
                .interestRate, that.detailedData.strikePrice, dtSale).toFixed(3)
              that.detailedData.delta = that.CalcPutDalta(that.detailedData.thePrice, askVolatility, that
                .detailedData
                .interestRate, that.detailedData.strikePrice, dtSale)
              that.detailedData.delta = that.detailedData.delta.toFixed(6)

              var VirtualValue = Math.max(that.sub(that.detailedData.strikePrice, that.detailedData.thePrice), 0),
                VirtualValue = that.mul(VirtualValue, that.detailedData.volume);
            }
            that.detailedData.buyPercent = this.mul(this.division(that.detailedData.buyPrice, that.detailedData.thePrice), 100)
              .toFixed(3) + '%'
            that.detailedData.salePercent = this.mul(this.division(that.detailedData.salePrice, that.detailedData.thePrice), 100)
              .toFixed(3) + '%'
            that.detailedData.buyVol = bidVolatility
            that.detailedData.saleVol = askVolatility
            that.detailedData.royalties = that.mul(that.detailedData.salePrice, that.detailedData.volume)

            // that.detailedData.margin = that.mul(that.detailedData.tradingMargin, Math.max(that.detailedData.delta, 0.2)).toFixed(2)
            // that.detailedData.margin = Math.max(that.sub(that.detailedData.tradingMargin, (that.mul(0.5, VirtualValue))), (that.mul(0.5, VirtualValue)));
            this.detailedData.margin = this.calcMargin(this.detailedData.thePrice, this.detailedData.strikePrice, this.detailedData.salePrice, this.detailedData.volume, data.marginRate, data.specialMarginRate, data.marginType, this.direction, that.detailedData.delta)
            // }
          }))
          reslove()
        })
        
      },
      numberChange: function () {
        this.detailedData.tradingMargin = this.mul(this.detailedData.thePrice, this.detailedData.volume)
        this.detailedData.tradingMargin = this.mul(this.detailedData.tradingMargin, this.detailedData.marginRate)
        this.detailedData.royalties = this.mul(this.detailedData.salePrice, this.detailedData.volume)
        // this.detailedData.margin = this.mul(this.detailedData.tradingMargin, Math.max(this.detailedData.delta, 0.2)).toFixed(2)
        var VirtualValue = Math.max(this.sub(this.detailedData.thePrice, this.detailedData.thePrice), 0),
          VirtualValue = this.mul(VirtualValue, this.detailedData.volume);
        this.detailedData.margin = Math.max(this.sub(this.detailedData.tradingMargin, (this.mul(0.5,
            VirtualValue))),
          (this.mul(0.5, VirtualValue)));
      },
      detailedPriceBuy(obj, direction) {
        this.orderData = obj
        this.orderDirection = direction

        // if(!this.userID) {
        //   this.$router.push('/Login')
        //   this.$message({
        //     type:'warning', 
        //     message: '检查到您还未登录,请先登录',
        //     showClose: true,
        //   })
        //   return
        // }

        let tradePassword = window.sessionStorage.getItem("tradePassword")
        if (!tradePassword) {
          this.dialogOrder = true
          return
        }

        this.optionOrder(obj, direction)

      },

      prompt: function () {
        this.modalPrompt = true
      },
      //  计算最新价格
      getNewPriceFun: function () { 
        for (let a = 0; a < this.newData.length; a++) {
          for(let j = 0; j < this.CacheData.length; j++) {
            if(this.newData[a].market == this.CacheData[j].exchange_id && this.newData[a].code == this.CacheData[j].instrument_id) {
              if (this.CacheData.length !== 0) {
                if (this.newData[a].price !== '') {
                  if (this.newData[a].price < this.CacheData[j].last_price) {
                    this.newData[a].call = true
                    this.newData[a].put = false
                  } else {
                    if (this.newData[a].price > this.CacheData[j].last_price) {
                      this.newData[a].call = false
                      this.newData[a].put = true
                    } else {}
                  }
                }
                if (!this.CacheData[j]) {
                  return
                }
                
                // var dateNum = []
                if(this.newData[a].yearSession == 365 || this.newData[a].yearSession == 0) {
                  var dateNum = this.DateDiff(this.nowDate, this.changeDate(this.expiryDate), this.newData[a].buyCpsDays, this.newData[a].sellCpsDays)
                } else {
                  if(!this.dayDiff) {
                    this.getDiff().then(day => {
                      var dateNum = [day + this.newData[a].buyCpsDays, day + this.newData[a].sellCpsDays]
                    })
                  } else {
                    var dateNum = [this.dayDiff + this.newData[a].buyCpsDays, this.dayDiff + this.newData[a].sellCpsDays]
                  }
                }
                // let dateNum = this.DateDiff(this.nowDate, this.changeDate(this.expiryDate), this.newData[a].buyCpsDays,
                //   this.newData[a].sellCpsDays)
                
                let bidDeduction = this.bid_deduction
                let askDeduction = this.ask_deduction 
                
                if(this.newData[a].yearSession == 365 || this.newData[a].yearSession == 0) {
                  var dtBuy = this.division(this.sub(dateNum[0], bidDeduction), 365)
                  var dtSale = this.division(this.sub(dateNum[1], askDeduction), 365)
                } else {
                  var dtBuy =  this.division(dateNum[0], this.newData[a].yearSession)
                  var dtSale =  this.division(dateNum[1], this.newData[a].yearSession)
                }
                let priceAccuracy = this.newData[a].priceAccuracy
                this.newData[a].price = Number(this.CacheData[j].last_price.toFixed(priceAccuracy))
                if (this.newData[a].bid_volatility !== 0 && this.newData[a].price !== 0) {
                  this.newData[a].sale = this.CalcCall(this.newData[a].price, this.newData[a].bid_volatility, this.newData[a].interest_rate, this.newData[a].price, dtBuy)
                  this.newData[a].buy = this.CalcCall(this.newData[a].price, this.newData[a].ask_volatility, this.newData[a].interest_rate, this.newData[a].price, dtSale)
                  if (this.buyLabel === '买价') {
                    this.newData[a].sale = this.newData[a].sale.toFixed(priceAccuracy)
                    this.newData[a].buy = this.newData[a].buy.toFixed(priceAccuracy)
                  } else if (this.buyLabel === '买价%') {
                    this.newData[a].buy = this.mul( this.division(this.newData[a].buy, this.newData[a].price), 100).toFixed(3) + '%'
                    this.newData[a].sale = this.mul( this.division(this.newData[a].sale, this.newData[a].price), 100).toFixed(3) + '%'
                  } else {
                    // this.newData[a].buy = (this.newData[a].bid_volatility * 100).toFixed(2) + '%'
                    // this.newData[a].sale = (this.newData[a].ask_volatility * 100).toFixed(2) + '%'
                    this.newData[a].buy = this.mul(this.newData[a].ask_volatility, 100).toFixed(3) + '%'
                    this.newData[a].sale = this.mul(this.newData[a].bid_volatility, 100).toFixed(3) + '%'
                  }
                } else {
                  this.newData[a].buy = '---'
                  this.newData[a].sale = '---'
                }
              } else {
                this.newData[a].price = 0
                this.newData[a].buy = '---'
                this.newData[a].sale = '---'
              }
              
            }
          }
          
        }
        this.newData.sort(p.by('CN_name', p.by('code')));
        this.newData.reverse()
        this.comCell()
      },
      conBai(BS, Price) {
        if(!BS.toString().indexOf('-') || BS.toString() == 'NaN' || parseFloat(BS) < 0 || !Price.toString().indexOf('-')) return '---'
        return this.mul(BS / Price, 100).toFixed(3) + '%'
      },
      changeMarket(market) {
        let str = '---'
        market = market.toUpperCase()
        switch (market) {
          case "SHFE":
            str = "上海期货交易所";
            break;
          case "DCE":
            str = "大连商品交易所";
            break;
          case "CZCE":
            str = "郑州商品交易所";
            break;
          case "INE":
            str = "上海国际能源交易中心";
            break;
          case "SGE":
            str = "上海黄金交易所";
            break;
          case "CFFEX":
            str = "中国金融期货交易所";
            break;
          case "HKFE":
            str = "香港期货交易所";
            break;
        }
        return str
      },

      changeVarietyName(obj) {
        let str = ''
        this.nameOptions.forEach(item => {
          if (item.product.toLowerCase() == obj.name.toLowerCase() && item.exchange.toLowerCase() == obj.market
            .toLowerCase()) {
            str = item.instrumentName
          }
        })
        if (str) {
          return str
        } else {
          return '---'
        }
      },
      enter() {
        this.$messgae({
          type:'success',
          message: '测试成功',
          showClose: true,
        })
      },
      handlerClose() {
        this.dialogOrder = false
      },
      openPassDialog() {
        this.tradePassword = ''
      },
      changeShowDate(date) {    //将20191010样式的时间转化为2019/10/10
        return this.timeFormat(this.timeyy(date), '/')
      },
      nightGetCounting() {   //在页面开始加载时启动定时器, 在晚上七点到九点查询夜盘的交易日
        if(new Date().getDay() == 6 || new Date().getDay() == 0) return   //周六日不用拉
        let end = this.getAccuracy('19:0:0')
        if(end < Date.now() && this.nowDate == this.timeFormat()) {      //如果是打开界面时间为7点以后且交易日还等于今天, 默认直接启动定时器
          this.nightLoopCurrentDate()
          return
        }
        let msec = this.timeDiff(end)
        setTimeout(() => {
          this.nightLoopCurrentDate()
        }, msec)
      },
      nightLoopCurrentDate() {
        this.getCurrentDate().then(nowDate => {
          let nine = this.getAccuracy('21:0:0')
          if(Date.now() > nine) {
            return
          }
          if(nowDate === this.nowDate) {
            setTimeout(() => {
              this.nightLoopCurrentDate()
            }, 300000)
          } else {
            this.nowDate = nowDate
            this.getCodeList()
          }
        })
        
      },
      morningGetCurrent() {
        if(new Date().getDay() == 6 || new Date().getDay() == 0) return   //周六日不用拉
        let begin = this.getAccuracy('7:0:0')
        let end = this.getAccuracy('9:0:0')
        let current = Date.now()
        if(current > end) {       //如果是九点打开界面以后就不用在请求了,设置晚上的定时器
          this.nightGetCounting()  //在晚上七点到九点查询夜盘的交易日
          return
        }    
        if(current < end && current >= begin) {     //7点到9点
          this.morningLoopCurrentDate()
          return
        }
        if(current < begin) {
          let msec = this.timeDiff(current, begin)
          setTimeout(() => {
            this.morningLoopCurrentDate()
          }, msec)
        }
      },
      morningLoopCurrentDate() {
        this.getCurrentDate().then(nowDate => {
          let end = this.getAccuracy('9:0:0')
          if(Date.now() > end) {
            this.nightGetCounting()  //在晚上七点到九点查询夜盘的交易日
            return
          }
          if(nowDate == this.timeFormat()) {    //早上请求过来的交易日等于今天, 停止请求
            this.nightGetCounting()  //在晚上七点到九点查询夜盘的交易日
            this.nowDate = nowDate
            return
          }
          if(nowDate === this.nowDate) {
            setTimeout(() => {
              this.morningLoopCurrentDate()
            }, 300000)
          } else {
            this.nowDate = nowDate
            this.nightGetCounting()  //在晚上七点到九点查询夜盘的交易日
            this.getCodeList()
          }
        })
      },
      comCell() {
        return new Promise((reslove, reject) => {
          let arr = []
          if(this.value == '板块') {
            this.plateNameOptions.forEach(name => {
              arr.push(this.newData.filter(item => item.plateName == name).length)
            })
          } else {
            this.exchangeNames.forEach(name => {
              arr.push(this.newData.filter(item => item.CN_name == name).length)
            })
          }
          this.equalityArray = arr
          reslove()
        })

      },
      getCellClass({row, column, rowIndex, columnIndex}) {
        if(columnIndex === 0) {
          if(row.CN_name == '未配置板块名') {
            return 'color5-subject'
          } else if(row.CN_name == "上海期货交易所" || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 1 ) {
            return 'color1-subject'
          } else if (row.CN_name == "郑州商品交易所" || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 2) {
            return 'color2-subject'
          } else if (row.CN_name == "大连商品交易所" || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 3 ) {
            return 'color3-subject'
          } else if(row.CN_name == "上海国际能源交易中心" || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 0 ) {
            return 'color4-subject'
          } else if(row.CN_name == "上海黄金交易所" || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 1 ) {
            return 'color1-subject'
          } else if (row.CN_name == "中国金融期货交易所" || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 2) {
            return 'color2-subject'
          } else if (row.CN_name == "香港期货交易所" || (this.plateNameOptions.indexOf(row.CN_name) + 1) % 4 == 3 ) {
            return 'color3-subject'
          } else {
            return 'color5-subject'
          }
        }
      },
      setTableHeader({row, rowIndex}) {
        return 'table-header'
      },
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
          if(this.value == '交易所') {
            let index = this.exchangeNames.indexOf(row.CN_name)
            let data = this.newData.filter(item => item.CN_name == row.CN_name)
            if(index !== -1) {
              if(row == data[0]) {
                return {
                  rowspan: this.equalityArray[index],
                  colspan: 1,
                }
              } else {
                return {
                  rowspan: 0,
                  colspan: 0,
                }
              }
            } else {
              return {
                rowspan: 0,
                colspan: 0,
              }
            }
          } else if(this.value == '板块') {
            let index = this.plateNameOptions.indexOf(row.plateName)
            let data = this.newData.filter(item => item.plateName == row.plateName)
            if(row == data[0]) {
              return {
                rowspan: this.equalityArray[index],
                colspan: 1,
              }
            } else {
              return {
                rowspan: 0,
                colspan: 0,
              }
            }
          }
        }
      }
      // objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //   if (columnIndex === 0) {
      //     if(row.CN_name == '上海期货交易所' || row.CN_name == '农产品') {
      //       let arr = []
      //       this.newData.forEach((item, index) => {
      //         if(item.CN_name === row.CN_name) {
      //           arr.push(index)
      //         }
      //       })
      //       if(rowIndex === arr[0]) {
      //         return {
      //           rowspan: this.equalityRow.one,
      //           colspan: 1
      //         }
      //       } else {
      //         return {
      //           rowspan: 0,
      //           colspan: 0,
      //         }
      //       }
      //     }

      //     if (row.CN_name == "郑州商品交易所" || row.CN_name == '有色与贵金属') {
      //       let arr = []
      //       this.newData.forEach((item, index) => {
      //         if(item.CN_name === row.CN_name) {
      //           arr.push(index)
      //         }
      //       })
      //       if(rowIndex === arr[0]) {
      //         return {
      //           rowspan: this.equalityRow.two,
      //           colspan: 1
      //         }
      //       } else {
      //         return {
      //           rowspan: 0,
      //           colspan: 0,
      //         }
      //       }
      //     }
      //     if (row.CN_name == "大连商品交易所" || row.CN_name == "能源化工") {
      //       let arr = []
      //       this.newData.forEach((item, index) => {
      //         if(item.CN_name === row.CN_name) {
      //           arr.push(index)
      //         }
      //       })
      //       if(rowIndex === arr[0]) {
      //         return {
      //           rowspan: this.equalityRow.three,
      //           colspan: 1
      //         }
      //       } else {
      //         return {
      //           rowspan: 0,
      //           colspan: 0,
      //         }
      //       }
      //     }
      //     let arr = []
      //       this.newData.forEach((item, index) => {
      //         if(item.CN_name === row.CN_name) {
      //           arr.push(index)
      //         }
      //       })
      //       if(rowIndex === arr[0]) {
      //       return {
      //         rowspan: this.equalityRow.four,
      //         colspan: 1
      //       }
      //     } else {
      //       return {
      //         rowspan: 0,
      //         colspan: 0,
      //       }
      //     }
      //   }
      // }
    },
    watch: {
      nowDate(newValue, oldValue) {
        if(!oldValue) return
        this.getDiff().then(day => {
          this.dayDiff = day
          this.fluctuation()
        })
      },
    }
  }

</script>

<style>
  #ol_article_content {
    height: 110px;
  }
  #ol_article_content img {
    vertical-align: top; 
    height: 110px;
  }
  #ol_article_content .title-right {
    background: #1f497d;
    color: #fff;
    height: 110px;
  }

  #ol_article_content .title-right .title-right-top {
    font-size: 24px;
    font-weight: 900;
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border-bottom: 1px solid #fff;
  }

  #ol_article_content .title-right .title-right-bottom {
    font-size: 20px;
    height: 50%;
    display: flex;
  }
  #ol_article_content .title-right .title-right-bottom p {
    height: 100%;
    width: 25%;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border-right: 1px solid #fff;
  }
  #ol_article_content .title-right .title-right-bottom p:last-child {
    border: 0;
  }

  .el-table {
    margin-left: 1px;
  }

  .table-header th {
    background: #1f497d !important;
    color: #fff;
    height: 40px !important;
    padding: 5px !important;
    padding: 0 !important;;
    font-size: 18px;
  }
  .table-header th .cell {
    font-weight: 700;
  }

  #pdf {
    width: 1000px;
    margin: 0 auto;
  }

  td {
    padding: 3px 0 !important;
  }

  #pdf .color5-even td {
    background:#fff;
    color: #000;
    font-size: 16px;
  }
  #pdf .color5-odd td {
    background:#fff;
    color: #000;
    font-size: 16px;
  }

  #pdf .color4-even td {
    background:#bfbfbf;
    color: #000;
    font-size: 16px;
  }
  #pdf .color4-odd td {
    background:#d9d9d9;
    color: #000;
    font-size: 16px;
  }

  #pdf .color3-even td {
    background-color: #e6b8b7;
    color: #000;
    font-size: 16px;
  }
  #pdf .color3-odd td {
    background-color: #f2dcdb;
    color: #000;
    font-size: 16px;
  }

  #pdf .color2-even td {
    background-color: #e4dfec;
    color: #000;
    font-size: 16px;
  }
  #pdf .color2-odd td {
    background-color: #ccc0da;
    color: #000;
    font-size: 16px;
  }

  #pdf .color1-even td {
    background-color: #ebf1de;
    color: #000;
    font-size: 16px;
  }
  #pdf .color1-odd td {
    background-color: #d8e4bc;
    color: #000;
    font-size: 16px;
  }

  #pdf .color1-subject  {
    background-color: #76933c !important;
    color: #fff !important;
    font-weight: 700 !important;
    font-size: 20px !important;
  }

  #pdf .color2-subject  {
    background-color: #60497a !important;
    color: #fff !important;
    font-weight: 700 !important;
    font-size: 20px !important;
  }

  #pdf .color3-subject  {
    background-color: #c0504d !important;
    color: #fff !important;
    font-weight: 700 !important;
    font-size: 20px !important;
    padding: 0 10px !important;
  }

  #pdf .color4-subject  {
    background-color: #404040 !important;
    color: #fff !important;
    font-weight: 700 !important;
    font-size: 20px !important;
    box-sizing: border-box;
    padding: 0 10px !important;
  }

  #pdf .color5-subject  {
    background-color: #fff !important;
    color: #000 !important;
    font-weight: 700 !important;
    font-size: 20px !important;
    box-sizing: border-box;
    padding: 0 10px !important;
  }

  .del {
    text-decoration: line-through;
  }

</style>
